import { accSub, padStart } from '@/utils'

/**
 * @param {贷款额度} baseLoan (万)
 * @param {贷款月数} month
 * @param {月利率} monthRate
 */
const getIntresetRs = (baseLoan = 0, month, monthRate) => {
    const loan = baseLoan * 10000
    const ratePowMonth = Math.pow((1 + monthRate), month)
    const monthPay = loan * monthRate * ratePowMonth / (ratePowMonth - 1)
    const totalPay = monthPay * month
    return {
        monthly_payment: monthPay, //每月还款
        total_interest: totalPay - loan, // 总利息
        total_payment: totalPay // 总还款
    }
}

const getIntresetMonth = (baseLoan, monthRate, monthPay) => {
    const ratePowMonth = monthPay / (monthPay - baseLoan * 10000 *  monthRate)
    return Math.ceil(Math.log(ratePowMonth) / Math.log(1 + monthRate))
}

/**
 * @param {贷款额度} baseLoan (万)
 * @param {贷款月数} month
 * @param {月利率} monthRate
 */
const getPrincipalRs = (baseLoan = 0, month, monthRate) => {
    const loan = baseLoan * 10000
    const firstMonthPayment = loan / month + loan * monthRate
    const monthlyLoan = loan / month
    const monthlyDecrease = monthlyLoan * monthRate
    const totalInterest = ((monthlyLoan + loan * monthRate) + monthlyLoan * (1 + monthRate)) / 2 * month - loan
    return {
        monthly_payment: firstMonthPayment, // 每月还款（其实是首月还款）
        total_interest: totalInterest, // 总利息
        total_payment: totalInterest + loan, // 总还款
        monthly_decrease: monthlyDecrease // 每月递减
    }
}

const getPrepayPrincipalRs = ({
    resetBase,
    resetMonth,
    base,
    month,
    monthRate
}) => {
    const resetBaseLoan = resetBase * 10000
    const baseLoan = base * 10000
    const monthlyLoan = baseLoan / month


    const firstMonthPayment = monthlyLoan + resetBaseLoan * monthRate


    const monthlyDecrease = monthlyLoan * monthRate
    const totalInterest = (
        (monthlyLoan + resetBaseLoan * monthRate)
        +
        monthlyLoan * (1 + monthRate)) / 2 * resetMonth - resetBaseLoan
    return {
        monthly_payment: firstMonthPayment, // 每月还款（其实是首月还款）
        total_interest: totalInterest, // 总利息
        total_payment: totalInterest + resetBaseLoan, // 总还款
        monthly_decrease: monthlyDecrease // 每月递减
    }
}

const getPrincipalMonth = (base_loan, spare_base, month) => {
    return Math.ceil((spare_base * 10000) / ((base_loan * 10000) / month))
}

const getMonthIntresetRs = (baseLoan, month, monthRate, monthNum, restPayment) => {
    const loan = baseLoan * 10000
    const { monthly_payment } = getIntresetRs(baseLoan, month, monthRate)
    const interest_payment = loan * monthRate * (Math.pow(1 + monthRate, month) - Math.pow(1 + monthRate, monthNum - 1)) /
        (Math.pow(1 + monthRate, month) - 1)
    const base_payment = monthly_payment - interest_payment
    const temp = accSub(restPayment, base_payment)
    const reset_payment = temp > 1 ? temp : 0
    return {
        monthly_payment,
        base_payment,
        interest_payment,
        reset_payment
    }
}

const getMonthPublicRs = (baseLoan, month, monthRate, monthNum, restPayment) => {
    const loan = baseLoan * 10000
    const base_payment = loan / month
    const totalPaidBase = (monthNum - 1) * base_payment
    const interest_payment = (loan - totalPaidBase) * monthRate
    const monthly_payment = base_payment + interest_payment
    const temp = accSub(restPayment, base_payment)
    const reset_payment = temp > 1 ? temp : 0
    return {
        monthly_payment,
        base_payment,
        interest_payment,
        reset_payment
    }
}

const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step))

export const LOAN_TYPES = [
    '商业贷款',
    '公积金贷款'
]

export const PAYMENT_TYPES = [
    '等额本息',
    '等额本金'
]

export const LOAN_YEARS = range(1, 30, 1).map(v => ({ text: v + '年', value: v}))

const current_date = new Date()

export const current_year = current_date.getFullYear()
export const current_month = current_date.getMonth() + 1

export const current_date_str = current_year + '-' + padStart(current_month)

export const YEARS = range(current_year - 30, current_year + 30, 1)

export const MONTH_OPTS = range(1, 12, 1)

export const PREPAYMENT_TYPES = [
    '一次性还清',
    '部分还款'
]

export const BUSINESS_BASE_RATES = [
    {
        year: '1997/10/23',
        value: '10.53'
    },
    {
        year: '1998/03/25',
        value: '10.53'
    },
    {
        year: '1998/07/01',
        value: '8.01'
    },
    {
        year: '1998/12/07',
        value: '7.56'
    },
    {
        year: '1999/06/10',
        value: '6.21'
    },
    {
        year: '2002/02/21',
        value: '5.76'
    },
    {
        year: '2004/10/29',
        value: '6.12'
    },
    {
        year: '2006/04/28',
        value: '6.39'
    },
    {
        year: '2006/08/19',
        value: '6.84'
    },
    {
        year: '2007/03/18',
        value: '7.11'
    },
    {
        year: '2007/05/19',
        value: '7.20'
    },
    {
        year: '2007/07/21',
        value: '7.38'
    },
    {
        year: '2007/08/22',
        value: '7.56'
    },
    {
        year: '2007/09/15',
        value: '7.83'
    },
    {
        year: '2007/12/21',
        value: '7.83'
    },
    {
        year: '2008/09/16',
        value: '7.74'
    },
    {
        year: '2008/10/30',
        value: '7.20'
    },
    {
        year: '2008/11/27',
        value: '6.12'
    },
    {
        year: '2008/12/23',
        value: '5.94'
    },
    {
        year: '2010/10/20',
        value: '6.14'
    },
    {
        year: '2010/12/26',
        value: '6.40'
    },
    {
        year: '2011/02/09',
        value: '6.60'
    },
    {
        year: '2011/04/06',
        value: '6.80'
    },
    {
        year: '2011/07/07',
        value: '7.05'
    },
    {
        year: '2012/06/08',
        value: '6.80'
    },
    {
        year: '2012/07/06',
        value: '6.55'
    },
    {
        year: '2014/11/22',
        value: '6.15'
    },
    {
        year: '2015/03/01',
        value: '5.90'
    },
    {
        year: '2015/05/11',
        value: '5.65'
    },
    {
        year: '2015/06/28',
        value: '5.40'
    },
    {
        year: '2015/08/26',
        value: '5.15'
    },
    {
        year: '2015/10/24',
        value: '4.90'
    }
]

export const PUBLIC_DISCOUNT_DEFAULT = 0

export const PUBLIC_DISCOUNT_OPTS = [
    {
        text: '无折扣',
        value: 1
    },
    {
        text: '上浮10%',
        value: 1.1
    }
]

export const PUBLIC_BASE_RATES = [
    {
        year: '1997/01/01',
        value: '8.10'
    },
    {
        year: '1999/09/21',
        value: '4.59'
    },
    {
        year: '2002/02/21',
        value: '4.05'
    },
    {
        year: '2004/10/29',
        value: '4.23'
    },
    {
        year: '2005/03/17',
        value: '4.41'
    },
    {
        year: '2006/04/28',
        value: '4.59'
    },
    {
        year: '2007/03/18',
        value: '4.77'
    },
    {
        year: '2007/05/19',
        value: '4.86'
    },
    {
        year: '2007/07/21',
        value: '4.95'
    },
    {
        year: '2007/08/22',
        value: '5.04'
    },
    {
        year: '2007/09/15',
        value: '5.22'
    },
    {
        year: '2007/12/21',
        value: '5.22'
    },
    {
        year: '2008/09/16',
        value: '5.13'
    },
    {
        year: '2008/10/09',
        value: '4.86'
    },
    {
        year: '2008/10/30',
        value: '4.59'
    },
    {
        year: '2008/11/27',
        value: '4.05'
    },
    {
        year: '2008/12/23',
        value: '3.87'
    },
    {
        year: '2010/10/20',
        value: '4.05'
    },
    {
        year: '2010/12/26',
        value: '4.30'
    },
    {
        year: '2011/02/09',
        value: '4.50'
    },
    {
        year: '2011/04/06',
        value: '4.70'
    },
    {
        year: '2011/07/07',
        value: '4.90'
    },
    {
        year: '2012/06/08',
        value: '4.70'
    },
    {
        year: '2012/07/06',
        value: '4.50'
    },
    {
        year: '2014/11/22',
        value: '4.25'
    },
    {
        year: '2015/03/01',
        value: '4.00'
    },
    {
        year: '2015/05/11',
        value: '3.75'
    },
    {
        year: '2015/06/28',
        value: '3.50'
    },
    {
        year: '2015/08/26',
        value: '3.25'
    }
]

export const BUSINESS_DISCOUNT_DEFAULT = 3

export const BUSINESS_DISCOUNT_OPTS = [
    {
        text: '上浮20%',
        value: 1.2
    },
    {
        text: '上浮15%',
        value: 1.15
    },
    {
        text: '上浮10%',
        value: 1.1
    },
    {
        text: '无折扣',
        value: 1
    },
    {
        text: '95折',
        value: 0.95
    },
    {
        text: '9折',
        value: 0.9
    },
    {
        text: '85折',
        value: 0.85
    }
]

const CalculateTotalMAp = {
    '等额本息': getIntresetRs,
    '等额本金': getPrincipalRs
}

const CalculateMonthMap = {
    '等额本息': getMonthIntresetRs,
    '等额本金': getMonthPublicRs
}

export const getLoanAllRs = ({ payment_type, base_moneny, month, month_rate }) => {
    return CalculateTotalMAp[payment_type](base_moneny, month, month_rate)
}

const getPaidMonth = (start_time, prepayment_time) => {
    return Math.floor((new Date(prepayment_time).getTime() - new Date(start_time).getTime()) / 1000 / 60 / 60 / 24 / 30)
}

const getPaidDetail = ({
    payment_type,
    base_moneny,
    month_rate,
    month,
    start_time,
    prepayment_time
}) => {
    const paid_month = getPaidMonth(start_time, prepayment_time)
    const base_loan = base_moneny * 10000
    let need_pay = base_loan
    const calc = CalculateMonthMap[payment_type]
    let base_payment_total = 0
    let interest_payment_total = 0
    let last_month_need_pay = 0
    const paid_clear_month = paid_month + 1
    let month_pay = 0
    let last_month_paid_base = 0
    let last_month_paid_interest = 0
    for (let month_num = 1; month_num <= paid_clear_month; month_num++) {
        const {
            monthly_payment,
            base_payment,
            interest_payment,
            reset_payment
        } = calc(base_moneny, month, month_rate, month_num, need_pay)
        month_pay = monthly_payment
        if (month_num === paid_clear_month) {
            last_month_need_pay = interest_payment
            last_month_paid_base = base_payment
            last_month_paid_interest = interest_payment
        } else {
            base_payment_total += base_payment
            interest_payment_total += interest_payment
            need_pay = reset_payment
        }
    }
    return {
        month_pay,
        last_month_need_pay,
        last_month_paid_base,
        last_month_paid_interest,
        paid_interest: interest_payment_total,
        paid_base: base_payment_total
    }
}

export const calcPayAll = (params) => {
    const formatDetail = (rs) => {
        rs.last_month_pay = rs.last_month_pay.toFixed(2)
        rs.paid_base = (rs.paid_base / 10000).toFixed(2)
        rs.paid_interest = (rs.paid_interest / 10000).toFixed(2)
        rs.save_interest = (rs.save_interest / 10000).toFixed(2)
        return rs
    }
    const {
        payment_type,
        base_moneny,
        year,
        start_time,
        rate,
        prepayment_time
    } = params
    const base_loan = base_moneny * 10000
    const month = year * 12
    const month_rate = rate / 12 / 100
    const {
        total_interest
    } = getLoanAllRs({ payment_type, base_moneny, month, month_rate })
    const {
        last_month_need_pay,
        paid_interest,
        paid_base
    } = getPaidDetail({ payment_type, base_moneny, month, start_time, prepayment_time, month_rate })
    const last_month_pay = base_loan - paid_base + last_month_need_pay
    return formatDetail({
        last_month_pay,
        save_interest: total_interest - paid_interest - last_month_need_pay,
        paid_interest,
        paid_base,
        prepayment_time
    })
}

const getTimeByMonth = (start, month) => {
    const start_times = start.split('-').map(v => Number(v))
    const start_year = start_times[0]
    const start_month = start_times[1]
    const target_month = start_month + month - 1
    let rs_year = Math.floor(target_month / 12) + start_year
    const rs_month = target_month % 12 || 12
    if (rs_month === 12) {
        rs_year--
    }
    return `${rs_year}-${padStart(rs_month)}`
}

export const decreasePay = ({
    base_moneny,
    payment_type,
    spare_base,
    month,
    month_rate,
    start_time,
    prepayment_time
}) => {
    const paid_month = getPaidMonth(start_time, prepayment_time) + 1
    const spare_month = month - paid_month
    const {
        monthly_payment,
        total_interest
    } = getLoanAllRs({ payment_type, base_moneny: spare_base, month: spare_month, month_rate })
    let save_interest
    if (payment_type === '等额本金') {
        const baseLoan = base_moneny * 10000
        const spareLoan = spare_base * 10000
        let beforeInterest = 0
        for (let v = paid_month + 1; v <= month; v++) {
            const monthlyCaptial =  baseLoan / month
            beforeInterest += getMonthPay(baseLoan, v, monthlyCaptial, month_rate)
        }
        let afterInterrest = 0
        for (let w = 1; w <= spare_month; w++) {
            const monthlyCaptial =  spareLoan / spare_month
            afterInterrest += getMonthPay(spareLoan, w, monthlyCaptial, month_rate)
        }
        save_interest = beforeInterest - afterInterrest
    }
    return {
        save_interest,
        month_pay: monthly_payment,
        total_interest,
        last_time: getTimeByMonth(start_time, month)
    }
}

export const decreaseMonth = ({
    base_moneny,
    payment_type,
    spare_base,
    month,
    month_rate,
    start_time,
    pre_month_pay,
    prepayment_time
}) => {
    const paid_month = getPaidMonth(start_time, prepayment_time) + 1
    let spare_month
    let rs
    if (payment_type === '等额本息') {
        spare_month = getIntresetMonth(spare_base, month_rate, pre_month_pay)
        rs = getIntresetRs(spare_base, spare_month, month_rate)
    } else {
        spare_month = getPrincipalMonth(base_moneny, spare_base, month)
        rs = getPrepayPrincipalRs({
            resetBase: spare_base,
            resetMonth: spare_month,
            base: base_moneny,
            month,
            monthRate: month_rate
        })
        const baseLoan = base_moneny * 10000
        const monthlyCaptial =  baseLoan/ month
        let beforeInterest = 0
        for (let v = paid_month + 1; v <= month; v++) {
            beforeInterest += getMonthPay(baseLoan, v, monthlyCaptial, month_rate)
        }
        let afterInterrest = 0
        for (let w = 1; w <= spare_month; w++) {
            afterInterrest += getMonthPay(spare_base * 10000, w, monthlyCaptial, month_rate)
        }
        rs.save_interest = beforeInterest - afterInterrest
    }

    const last_time = getTimeByMonth(start_time, spare_month + paid_month)

    const {
        monthly_payment,
        total_interest,
        save_interest
    } = rs
    return {
        month_pay: monthly_payment,
        total_interest,
        last_time,
        save_interest
    }
}

const getMonthPay = (base, monthNum, monthlyCaptial, monthRate) => {
    return (base - (monthNum - 1) * monthlyCaptial) * monthRate
}


export const calcPayPartition  =(params) => {
    const formatDetail = (rs) => {
        rs.last_month_pay = rs.last_month_pay.toFixed(2)
        rs.paid_interest = (rs.paid_interest / 10000).toFixed(2)
        rs.paid_base = (rs.paid_base / 10000).toFixed(2)
        rs.decrease_pay.month_pay = rs.decrease_pay.month_pay.toFixed(2)
        rs.decrease_pay.save_interest = (rs.decrease_pay.save_interest / 10000).toFixed(2)
        rs.decrease_month.month_pay = rs.decrease_month.month_pay.toFixed(2)
        rs.decrease_month.save_interest = (rs.decrease_month.save_interest / 10000).toFixed(2)
        return rs
    }
    const {
        payment_type,
        base_moneny,
        year,
        start_time,
        rate,
        prepayment_time,
        prepayment_money
    } = params
    const base_loan = base_moneny * 10000
    const month = year * 12
    const month_rate = rate / 12 / 100

    // 计算原来应还
    const {
        total_interest
    } = getLoanAllRs({ payment_type, base_moneny, month, month_rate })

    // 计算已还
    const {
        paid_interest,
        paid_base,
        month_pay,
        last_month_paid_interest,
        last_month_paid_base
    } = getPaidDetail({ payment_type, base_moneny, month, start_time, prepayment_time, month_rate })

    const spare_base = (base_loan - paid_base - prepayment_money * 10000 - last_month_paid_base) / 10000

    // 计算月数不变
    const decrease_pay = decreasePay({
        base_moneny,
        payment_type,
        spare_base,
        month,
        month_rate,
        start_time,
        prepayment_time
    })

    // 计算本金不变
    const decrease_month = decreaseMonth({
        base_moneny,
        payment_type,
        spare_base,
        month,
        month_rate,
        start_time,
        prepayment_time,
        pre_month_pay: month_pay
    })

    const spare_interest = total_interest - paid_interest - last_month_paid_interest
    return formatDetail({
        last_month_pay: month_pay + prepayment_money * 10000,
        paid_interest,
        paid_base,
        decrease_pay: {
            month_pay: decrease_pay.month_pay,
            save_interest:
                decrease_pay.save_interest ?
                    decrease_pay.save_interest
                    :
                    (spare_interest - decrease_pay.total_interest),
            last_time: decrease_pay.last_time
        },
        decrease_month: {
            month_pay: decrease_month.month_pay,
            save_interest: decrease_month.save_interest ?
                decrease_month.save_interest
                :
                (spare_interest - decrease_month.total_interest),
            last_time: decrease_month.last_time
        }
    })
}
